import React, { type FunctionComponent } from 'react'
import qs from 'query-string'
import { FormattedMessage } from 'react-intl'

import { type KeyValueString } from 'legacy/common/types'
import { BreadcrumbLink } from 'legacy/components/Breadcrumbs'

export type OrderDetailsBackBreadcrumbProps = {
  deliveryUrl: string
  pickupUrl: string
  isPickup: string
  query: KeyValueString
}

export const OrderDetailsBackBreadcrumb: FunctionComponent<OrderDetailsBackBreadcrumbProps> = ({
  deliveryUrl,
  isPickup,
  pickupUrl,
  query,
}) => {
  const url = isPickup ? pickupUrl : deliveryUrl
  const stringId = isPickup ? 'pickup.title' : 'delivery.title'

  return (
    <BreadcrumbLink
      to={{
        pathname: url,
        search: qs.stringify(query),
      }}
    >
      <FormattedMessage id={stringId} />
    </BreadcrumbLink>
  )
}
